import CompanyGroupList from '@/components/CompanyGroup/CompanyGroupList'
import CompanyGroupForm from '@/components/CompanyGroup/CompanyGroupForm'
import CompanyGroupDetail from '@/components/CompanyGroup/CompanyGroupDetail'

let CompanyGroupRouter = [{
  path: '/company_group',
  name: 'CompanyGroupList',
  component: CompanyGroupList,
  meta: {
    title: "Familles d'entreprise",
    requiresAuth: true,
    authorizations: ['company-group_index', 'desktop_access']
  }
}, {
  path: '/company_group/new',
  name: 'CompanyGroupNew',
  component: CompanyGroupForm,
  meta: {
    title: "Nouvelle famille d'entreprise",
    requiresAuth: true,
    authorizations: ['company-group_new', 'desktop_access']
  }
}, {
  path: '/company_group/:id/edit',
  name: 'CompanyGroupEdit',
  component: CompanyGroupForm,
  meta: {
    title: "Modifier une famille d'entreprise",
    requiresAuth: true,
    authorizations: ['company-group_edit', 'desktop_access']
  }
}, {
  path: '/company_group/:id',
  name: 'CompanyGroupDetail',
  component: CompanyGroupDetail,
  meta: {
    title: "Fiche famille d'entreprise",
    requiresAuth: true,
    authorizations: ['company-group_show', 'desktop_access']
  }
}]

export default CompanyGroupRouter



// WEBPACK FOOTER //
// ./src/components/CompanyGroup/router.js